export default __webpack_public_path__ + "static/media/cointracker.b4030439.jpg";